import { useTranslation } from "react-i18next";
import { Modal } from "semantic-ui-react";

import "modules/WebhooksDashboard/components/WebhooksErrorsModal/WebhooksErrorsModal.scss";
import { WebhooksErrorsTable } from "modules/WebhooksDashboard/components/WebhooksErrorsModal/WebhooksErrorsTable";

type WebhooksErrorsModalProps = {
  webhook_id: number | null;
  onClose: () => void;
};

export const WebhooksErrorsModal = ({ webhook_id, onClose }: WebhooksErrorsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={!!webhook_id} onClose={onClose} size="large" closeIcon>
      <Modal.Header> {t("v8_error_log", "Error Log")} </Modal.Header>
      <Modal.Content scrolling>
        <WebhooksErrorsTable webhook_id={webhook_id} />
      </Modal.Content>
    </Modal>
  );
};
